define('views/content/admin_home',['require','backbone','marionette','bootstrap-daterangepicker','jquery.scrollbar','d3','nvd3','text!templates/content/admin_home.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('bootstrap-daterangepicker');
    require('jquery.scrollbar');
    var d3 = require('d3');
    var nv = require('nvd3');

    var temp = require("text!templates/content/admin_home.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'admin-home-page',
        titleKey: 'home',

        initialize: function(options) {
            this.initialReportsLoaded = false;
            this.reseller_countries = [];
            this.customer_countries = [];

            this.customer_count_value = null;
            this.reseller_count_value = null;
            this.distributor_count_value = null;
            this.license_count_value = null;
            this.revenue_value = null;
            this.customer_counts_by_version = [];
            this.sold_license_data = null;

            this.rangeStartDate = null;
            this.rangeEndDate = null;
            this.selectedRangeTab = null;

            App.context.changePageTitle(App.polyglot.t(this.titleKey));

            this.getCountryReports();
        },

        ui: function() {
            return {
                reportDateRangePicker: '#report-range-picker',
                reportDateRangeTabs: '.report-range-tabs',
                reportDateRangeTab: '.report-range-tabs li',

                customerCount: '.customer-count',
                resellerCount: '.reseller-count',
                distributorCount: '.distributor-count',
                licenseCount: '.license-count',
                revenue: '.revenue',

                countryTableContainer: '.country-table-container'
            };
        },

        events: {
            'click @ui.reportDateRangeTab': 'reportDateRangeTabClicked'
        },

        templateHelpers: function() {
            return {
                reseller_countries: this.reseller_countries,
                customer_countries: this.customer_countries,
                customer_counts_by_version: this.customer_counts_by_version,
                customer_count_value: this.customer_count_value,
                reseller_count_value: this.reseller_count_value,
                distributor_count_value: this.distributor_count_value,
                license_count_value: this.license_count_value,
                revenue_value: this.revenue_value,
                selectedRangeTab: this.selectedRangeTab
            };
        },

        onRender: function () {
            var _this = this;

            this.ui.reportDateRangePicker.daterangepicker({
                timePicker: false,
                format:'YYYY-MM-DD',
                autoApply: true
            });

            if (this.rangeStartDate && this.rangeEndDate) {
                this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(this.rangeStartDate);
                this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(this.rangeEndDate);
            }

            this.ui.reportDateRangePicker.on('hide.daterangepicker', function () {
                _this.selectedRangeTab = null;
                _this.rangeStartDate = _this.ui.reportDateRangePicker.data('daterangepicker').startDate;
                _this.rangeEndDate = _this.ui.reportDateRangePicker.data('daterangepicker').endDate;

                _this.getAdminReports();
            });

            this.ui.countryTableContainer.scrollbar();

            if (this.sold_license_data) {
                this.showLicensesChart(this.sold_license_data);
            }

            if (!this.initialReportsLoaded) {
                this.ui.reportDateRangeTabs.find('li[data-range="day"]').click();
            }
        },

        reportDateRangeTabClicked: function (e) {
            var clickedTab = $(e.currentTarget);
            var currentTab = this.ui.reportDateRangeTabs.find('li.active');

            if (clickedTab != currentTab) {
                currentTab.removeClass('active');
                clickedTab.addClass('active');

                var rangeKey = clickedTab.attr('data-range');
                this.selectedRangeTab = rangeKey;

                var tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                if (rangeKey == 'day') {
                    var today = new Date();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(today);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'week') {
                    var weekStart = App.utils.getWeekStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(weekStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                } else if (rangeKey == 'month') {
                    var monthStart = App.utils.getMonthStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(monthStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);

                } else if (rangeKey == 'year') {
                    var yearStart = App.utils.getYearStart();

                    this.ui.reportDateRangePicker.data('daterangepicker').setStartDate(yearStart);
                    this.ui.reportDateRangePicker.data('daterangepicker').setEndDate(tomorrow);
                }

                this.rangeStartDate = this.ui.reportDateRangePicker.data('daterangepicker').startDate;
                this.rangeEndDate = this.ui.reportDateRangePicker.data('daterangepicker').endDate;

                this.getAdminReports();
            }
        },

        showLicensesChart: function (licenseData) {
            nv.addGraph(function() {
                var chart = nv.models.discreteBarChart()
                    .x(function(d) { return d.product_name; })
                    .y(function(d) { return d.count; })
                    .showValues(true);

                chart.yAxis.tickFormat(d3.format(',f'));
                chart.xAxis.rotateLabels(-45);
                chart.valueFormat(d3.format('d'));

                d3.select(".license-chart-container svg")
                    .datum([{
                        key: App.polyglot.t('licenses'),
                        values: licenseData.sort(function (a, b) {
                            return a.count > b.count ? -1 : 1;
                        })
                    }])
                    .call(chart);

                nv.utils.windowResize(chart.update);

                return chart;
            });
        },

        getAdminReports: function () {
            this.initialReportsLoaded = true;

            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/admin-reports/',
                method: 'get',
                data: {
                    start_date: this.ui.reportDateRangePicker.data('daterangepicker').startDate.format('YYYY-MM-DD'),
                    end_date: this.ui.reportDateRangePicker.data('daterangepicker').endDate.format('YYYY-MM-DD')
                },
                success: function (response) {
                    _this.customer_count_value = response.customer_count + ' / ' + response.customer_count_w_licenses;
                    _this.reseller_count_value = response.reseller_count;
                    _this.distributor_count_value = response.distributor_count;
                    _this.license_count_value = response.purchase_count;
                    _this.revenue_value = '$' + Math.round(response.revenue).toFixed(2);
                    _this.sold_license_data = response.sold_licenses;
                    _this.customer_counts_by_version = response.customer_counts_by_version;

                    _this.render();
                }
            });
        },

        getCountryReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/country-reports/',
                method: 'get',
                success: function (response) {
                    _this.reseller_countries = response.reseller_countries;
                    _this.customer_countries = response.customer_countries;

                    _this.render();
                }
            });
        }

    });
});
